import { render, staticRenderFns } from "./RefuseWorker.vue?vue&type=template&id=05dd4945&scoped=true&"
import script from "./RefuseWorker.vue?vue&type=script&lang=js&"
export * from "./RefuseWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd4945",
  null
  
)

export default component.exports